import { API } from "../../api";
import { objectToQueryString } from "../../../helpers/objectToQueryString";
async function getProducts(query) {
    const url = process.env.LETS_TRADE_PRODUCT_URL ?? "";
    // Check if IProductsRequest has the attributes property.
    // If attributes are present, we can use them for filtering.
    if (query?.attributes) {
        // const { name, value } = query.attributes;
        for (const { name, value } of query.attributes) {
            const attributesString = JSON.stringify({ type: "LIST", value: value });
            // Add the attribute filter directly to the query object
            query[`attributes[${name}]`] = attributesString;
        }
        // Remove attributes from the query to avoid confusion.
        delete query.attributes;
    }
    return (await new API().apiGet({
        baseUrl: url,
        endpoint: `v2/product/list${objectToQueryString(query)}`,
    }));
}
export { getProducts };
